import React from 'react';
import { Choice } from './common/PumpChoice';

interface IProps {
    choices: Choice[],
    clicked?: (choice: Choice) => void
}

/**
 * The Breadcrumb function component is responsible for displaying all choices 
 * made in the PumpChoiceSelector component, and providing a way to navigate
 * back to any given choice.
 */
export const Breadcrumb = (props: IProps) : JSX.Element => {
    const breadcrumbClicked = (choice: Choice): void => {
        if (!props.clicked) {
            return;
        }
        props.clicked(choice);
    };
    return (
        <div className='bap-row'>
            <div className='bap-col-6'>
                <ul id='breadcrumb'>
                    {props.choices.map((choice, index) => (
                        <li key={index}>
                            <span onClick={() => {breadcrumbClicked(choice)}}>{choice.value}</span>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
